import { render, staticRenderFns } from "./CancellationSectionOverview.vue?vue&type=template&id=3b4c22dc"
import script from "./CancellationSectionOverview.vue?vue&type=script&lang=js"
export * from "./CancellationSectionOverview.vue?vue&type=script&lang=js"
import style0 from "./CancellationSectionOverview.vue?vue&type=style&index=0&id=3b4c22dc&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports